import UserTable from '@/components/dashboard/users/userTable';
import { useAuth } from '@/lib/auth';
import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_protected/dashboard/users')({
  component: RouteComponent,
});

function RouteComponent() {
  const { isAdmin } = useAuth();

  if (!isAdmin()) {
    return <Navigate to="/dashboard/matchs" />;
  }

  return (
    <section className="w-[80%] flex flex-grow flex-col gap-4 ">
      <UserTable />
    </section>
  );
}
